const LOCAL_STORA_NAME = 'sisu:result'
const LOCAL_STORA_SUBSCRIBER = 'sisu:subscriber'
export function setLocalStorageResult(data: object) {
  localStorage?.setItem(LOCAL_STORA_NAME, JSON.stringify(data))
}

export function clearLocalStorageResult() {
  localStorage?.removeItem(LOCAL_STORA_NAME)
}

export function getLocalStorageResult() {
  let data = null

  if (typeof localStorage !== `undefined`) {
    data = localStorage?.getItem(LOCAL_STORA_NAME)
  }

  if (!data) {
    return undefined
  }

  return JSON.parse(data)
}

export function setLocalStorageSubscriber(data: object){
  localStorage?.setItem(LOCAL_STORA_SUBSCRIBER, JSON.stringify(data))
}

export function clearLocalStorageSubscriber() {
  localStorage?.removeItem(LOCAL_STORA_SUBSCRIBER)
}

export function getLocalStorageSubscriber() {
  let data = null

  if (typeof localStorage !== `undefined`) {
    data = localStorage?.getItem(LOCAL_STORA_SUBSCRIBER)
  }

  if (!data) {
    return undefined
  }

  return JSON.parse(data)
}
